import { Link } from 'react-router-dom';
import PartnerForm from '../Components/partners/PartnerForm';

const benefits = [
  ['Partner enablement', 'Discuss onboarding, product demonstrations, and team training.'],
  ['School workflows', 'Show schools lessons, classes, approvals, and browser or headset experiences.'],
  ['Program support', 'Explore commercial terms and territory needs with the In3D.ai team.'],
];

export default function ChannelPartners() {
  return (
    <div className="min-h-screen bg-[#04070f] text-white">
      <header className="border-b border-white/10">
        <div className="mx-auto flex max-w-[1180px] items-center justify-between px-5 py-5 sm:px-8">
          <Link to="/" className="font-display text-xl font-bold">In3D.ai</Link>
          <nav className="flex items-center gap-5 text-sm text-white/65" aria-label="Partner navigation">
            <Link to="/case-studies">Case Studies</Link>
            <Link to="/web-preview">Explore platform</Link>
            <Link to="/partner-login">Partner sign in</Link>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-[1180px] px-5 py-20 sm:px-8">
        <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-cyan-200/80">Partner program</p>
        <h1 className="mt-5 max-w-4xl font-display text-5xl font-bold tracking-[-0.04em] sm:text-7xl">Grow with In3D.ai</h1>
        <p className="mt-6 max-w-2xl text-lg leading-8 text-white/60">
          Bring immersive, AI assisted learning to schools in your market with browser and headset experiences.
        </p>
        <div className="mt-9 flex flex-col gap-3 sm:flex-row">
          <a href="#apply" className="inline-flex h-12 items-center justify-center rounded-full bg-cyan-300 px-6 text-sm font-semibold text-slate-950">Apply now</a>
          <Link to="/partner-login" className="inline-flex h-12 items-center justify-center rounded-full border border-white/20 px-6 text-sm text-white">Partner sign in</Link>
        </div>
        <section className="mt-20">
          <h2 className="font-display text-3xl font-semibold">Partner opportunities</h2>
          <div className="mt-8 grid gap-5 md:grid-cols-3">
            {benefits.map(([title, body]) => (
              <article key={title} className="rounded-[22px] border border-white/10 bg-white/[0.035] p-7">
                <h3 className="font-display text-xl font-semibold">{title}</h3>
                <p className="mt-3 text-sm leading-6 text-white/60">{body}</p>
              </article>
            ))}
          </div>
        </section>
        <section id="apply" className="mt-20 max-w-3xl scroll-mt-10">
          <h2 className="mb-8 font-display text-3xl font-semibold">Apply to partner with In3D.ai</h2>
          <PartnerForm />
        </section>
      </main>
      <footer className="border-t border-white/10 px-5 py-8 text-center text-sm text-white/40">© 2026 Evoneural AI. All rights reserved.</footer>
    </div>
  );
}
